<template>
  <v-container grid-list-md>
    <v-row>
      <v-col><h1 style="font-size:40px;color: #48445E;">About Me</h1></v-col>
    </v-row>
    <br /><br />
    <v-row
      class="d-flex align-sm-center justify-xs-center  flex-sm-column flex-md-row"
    >
      <v-col md="4" data-aos="fade-up">
        <img src="@/assets/1.png" width="80%" />
      </v-col>
      <v-col md="8" class="personalBox" data-aos="fade-up">
        <v-row class="d-flex align-start">
          <v-col md="6">
            <p>
              Hi! <br />
              I am Aunyamanee Srilerd, new graduate from The computer
              engineering major
              <br />I'm into for web development, love to make website and
              learns new technology<br />
            </p>
            <button class="btn_DownloadCV" @click="download()">
              Download Resume
            </button>
          </v-col>
          <v-col md="6">
            <v-row class="d-flex progressBar flex-column  justify-start">
              <span>
                <h3>Love Score 💖</h3>
                <span
                  style="color: #48445E;"
                  class="d-flex  flex-row  justify-space-between"
                  >Front-End Development
                  <p>100%</p></span
                >
                <v-progress-linear
                  class="progress"
                  height="7"
                  color="#6FECCD"
                  value="100"
                ></v-progress-linear>
              </span>
              <span>
                <span
                  style="color: #48445E;"
                  class="d-flex  flex-row  justify-space-between"
                  >Back-End Development
                  <p>40%</p></span
                >
                <v-progress-linear
                  class="progress"
                  height="7"
                  color="#FF3555"
                  value="40"
                ></v-progress-linear>
              </span>
              <span>
                <span
                  style="color: #48445E;"
                  class="d-flex  flex-row  justify-space-between"
                  >Ux/Ui Design
                  <p>60%</p></span
                >
                <v-progress-linear
                  class="progress"
                  height="7"
                  color="#6C6CE5"
                  value="60"
                ></v-progress-linear>
              </span>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
//  AOS.init();
export default {
  name: "about",
  methods: {
    download() {
      window.open(
        "https://drive.google.com/file/d/127_uBQPB3jE5024iLFBiAK2FSKnUyx-a/view?usp=sharing"
      );
    },
  },
};
</script>
<style scoped>
.personalBox {
  width: auto;
  height: auto;
  max-height: auto;
  background: white;
  border-radius: 20px;
  box-shadow: 0px 10px 20px rgba(128, 128, 128, 0.075);
  padding: 2em;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  line-height: 1.6;
  color: gray;
}

.btn_DownloadCV {
  padding: 10px 20px 10px 20px;
  border-radius: 25px;
  color: white;
  background-color: #ff3555;
  outline: none;
}
.btn_DownloadCV:active {
  color: #ff3555;
  background: white;
  border: 1px solid #ff3555;
}
.btn_DownloadCV:hover {
  transform: scale(0.9);
  transition-duration: 0.5s;
}
.progress {
  border-radius: 50px;
  /* margin-top: 2px; */
  background: rgb(255, 255, 255);
}
.progressBar span {
  margin-top: 5px;
  /* padding: 5px; */
  color: black;
  font-weight: 500;
}
.progressBar span h3 {
  color: gray;
  margin-bottom: 10px;
}
@media screen and (max-width: 600px) {
  .row {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}
</style>
